import { css as u, LitElement as d, html as y } from "lit";
import { state as f, property as n } from "lit/decorators.js";
import { unsafeSVG as g } from "lit/directives/unsafe-svg.js";
const w = { glob: "icons/system/(arrow-*|caret-*|checkmark|close|info-circle-fill|menu|minus|new-window|plus|search|tiles-fill|warning-fill).svg", output: "raw" }, b = [u`:host{display:inline-block;height:1em;width:1em}svg{display:block;fill:currentColor;max-height:100%;max-width:100%}:host([library=decorative][size=large]) path{vector-effect:non-scaling-stroke}:host([library=two-color]) [fill='#78BE20']{fill:var(--nc-icon-two-color-accent-color,#78be20)}:host([library=two-color]) [fill='#114A21']{fill:var(--nc-icon-two-color-primary-color,#114a21)}svg:not(:root){overflow:visible}`];
var v = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, a = (h, t, e, i) => {
  for (var s, r = i > 1 ? void 0 : i ? _(t, e) : t, p = h.length - 1; p >= 0; p--)
    (s = h[p]) && (r = (i ? s(t, e, r) : s(r)) || r);
  return i && r && v(t, e, r), r;
};
const l = new Map(Object.entries(w)), c = /* @__PURE__ */ new Map(), o = class m extends d {
  constructor() {
    super(...arguments), this._content = "", this.ratio = null, this._setIcon = async () => {
      const t = `${[this.library || "system", this.size, this.family, this.name].filter((s) => s != null).join("/")}.svg`;
      if (l.has(t))
        return void (this._content = l.get(t));
      let e;
      if (c.has(t))
        e = await c.get(t);
      else {
        const s = fetch(`${m.path}/icons/${t}`, { mode: "same-origin" });
        c.set(t, s), e = await s;
      }
      if (!e.ok)
        return void (this._content = "");
      const i = await e.clone().text();
      this._content = i, l.has(t) || (l.set(t, i), c.delete(t));
    };
  }
  _a11yCheck(t) {
    let e = t;
    return this.label != null && (e = e.replace("<svg ", `<svg role="img" aria-label="${this.label}" `), t.includes('aria-hidden="true"') && (e = e.replace('aria-hidden="true"', ""))), e;
  }
  _setRatio() {
    if (this.ratio) {
      const [t, e] = this.ratio.split(":");
      let i = parseInt(e, 10), s = parseInt(t, 10);
      const r = Math.min(i, s);
      i /= r, s /= r, this.style.height = `${i}em`, this.style.width = `${s}em`;
    } else
      this.style.height && (this.style.height = ""), this.style.width && (this.style.width = "");
  }
  firstUpdated(t) {
    (t.has("name") || t.has("family") || t.has("library") || t.has("size")) && this._setIcon();
  }
  shouldUpdate(t) {
    return t.has("name") || t.has("family") || t.has("library") || t.has("size") ? (this._setIcon(), !0) : super.shouldUpdate(t);
  }
  updated(t) {
    this._setRatio(), super.updated(t);
  }
  render() {
    return this.name && this._content ? y`${g(this._a11yCheck(this._content))}` : y`<slot></slot>`;
  }
};
o.styles = b, o.cache = (h) => {
  Object.entries(h).forEach(([t, e]) => {
    l.has(t) || l.set(t, e);
  });
}, o.path = "assets", a([f()], o.prototype, "_content", 2), a([n({ type: String })], o.prototype, "name", 2), a([n({ type: String })], o.prototype, "family", 2), a([n({ type: String })], o.prototype, "library", 2), a([n({ type: String })], o.prototype, "size", 2), a([n({ type: String })], o.prototype, "label", 2), a([n({ type: String })], o.prototype, "ratio", 2);
let k = o;
customElements.get("nucleus-icon") || customElements.define("nucleus-icon", k);
export {
  k as NucleusIcon
};
